import { inject, Injectable } from '@angular/core';
import { DrawerService } from '@pf/shared-ui';
import { CpwErrorDrawerComponent } from '../components/cpw-error-drawer.component';

@Injectable({
    providedIn: 'root',
})
export class CpwInputErrorService {
    private readonly drawerService = inject(DrawerService);

    showError(
        error: string,
        providedInput: string,
        expectedInput?: string,
        onClose?: () => void
    ) {
        this.drawerService.createTemplateDrawer({
            title: 'Scan Error',
            content: CpwErrorDrawerComponent,
            onClose: onClose,
            data: {
                error,
                providedInput,
                expectedInput,
            },
        });
    }
}
